const STORYBLOK_API_KEY = 'ACFG1Sqke88EDDH4HuhBBgtt';
const STORYBLOK_PUBLIC_KEY = 'G2pTaJQ3jJIy15NOMxYSDQtt';

module.exports.public = STORYBLOK_PUBLIC_KEY
module.exports = STORYBLOK_API_KEY;
